import {NgModule} from '@angular/core';
import {ButtonModule} from 'primeng/button';
import {ListboxModule} from 'primeng/listbox';
import {TableModule} from "primeng/table";
import {MessagesModule} from "primeng/messages";
import {MessageModule} from "primeng/message";
import {ToastModule} from "primeng/toast";
import {CheckboxModule} from "primeng/checkbox";
import {ScrollPanelModule} from "primeng/scrollpanel";
import {ToolbarModule} from "primeng/toolbar";
import {FileUploadModule} from "primeng/fileupload";
import {MenubarModule} from "primeng/menubar";
import {RadioButtonModule} from "primeng/radiobutton";
import {DynamicDialogModule} from "primeng/dynamicdialog";
import {TabViewModule} from "primeng/tabview";
import {AutoCompleteModule} from "primeng/autocomplete";
import {ConfirmDialogModule} from "primeng/confirmdialog";
import {MultiSelectModule} from "primeng/multiselect";
import {SliderModule} from "primeng/slider";
import {AccordionModule} from "primeng/accordion";
import {TextareaModule} from "primeng/textarea";
import {ColorPickerModule} from "primeng/colorpicker";
import {ToggleButtonModule} from "primeng/togglebutton";
import {InputNumberModule} from "primeng/inputnumber";
import {DialogModule} from "primeng/dialog";
import {SelectModule} from 'primeng/select';
import {PopoverModule} from 'primeng/popover';
import {TabsModule} from "primeng/tabs";
import {ImageModule} from "primeng/image";
import {TreeModule} from "primeng/tree";
import {ContextMenuModule} from "primeng/contextmenu";
import {BreadcrumbModule} from "primeng/breadcrumb";

@NgModule({
  declarations: [],
  imports: [],
  exports: [
    ButtonModule,
    ListboxModule,
    TableModule,
    MessagesModule,
    MessageModule,
    ToastModule,
    CheckboxModule,
    ScrollPanelModule,
    ToolbarModule,
    FileUploadModule,
    MenubarModule,
    RadioButtonModule,
    DynamicDialogModule,
    AutoCompleteModule,
    ConfirmDialogModule,
    MultiSelectModule,
    SliderModule,
    AccordionModule,
    TextareaModule,
    ColorPickerModule,
    ToggleButtonModule,
    InputNumberModule,
    DialogModule,
    SelectModule,
    PopoverModule,
    TabsModule,
    ImageModule,
    TreeModule,
    ContextMenuModule,
    ConfirmDialogModule,
    BreadcrumbModule
  ],
})
export class SharedPrimeNgModule {
}
